import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=7b85789e&"
import script from "./Main.vue?vue&type=script&lang=js&"
export * from "./Main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7b85789e', component.options)
    } else {
      api.reload('7b85789e', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=7b85789e&", function () {
      api.rerender('7b85789e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Layout/Main.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Main.vue
// module id = 6WkX
// module chunks = 0